import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    Label,
    Textarea,
} from "@/shared/components";
import { useState } from "react";

interface ToelichtingDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    existingToelichting: string | undefined;
    /**
     * Show in dialog title after "Toelichting toevoegen/wijzigen"
     */
    titelSuffix: string;
    onSave: (toelichting: string) => void;
}

export function ToelichtingDialog({ open, onOpenChange, existingToelichting, titelSuffix, onSave }: Readonly<ToelichtingDialogProps>) {
    const [toelichting, setToelichting] = useState(existingToelichting ?? "");
    const isEditing = Boolean(existingToelichting);

    const handleSubmit = () => {
        onSave(toelichting);
        onOpenChange(false);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContainer>
                <DialogHeader>
                    <DialogTitle>
                        {isEditing ? "Toelichting wijzigen" : "Toelichting toevoegen"} {titelSuffix}
                    </DialogTitle>
                </DialogHeader>

                <DialogBody className="grid gap-4">
                    <DialogDescription>Voeg eventueel een toelichting toe voor de Regievoerder.</DialogDescription>
                    <div>
                        <Label htmlFor="toelichting" className="mb-1">
                            Toelichting
                        </Label>
                        <Textarea
                            id="toelichting"
                            value={toelichting}
                            rows={3}
                            onChange={(e) => setToelichting(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder={isEditing ? existingToelichting : "Voer toelichting in..."}
                        />
                    </div>
                </DialogBody>

                <DialogFooter>
                    <Button variant="tertiary" onClick={() => onOpenChange(false)}>
                        Annuleren
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        {isEditing ? "Opslaan" : "Toevoegen"}
                    </Button>
                </DialogFooter>
            </DialogContainer>
        </Dialog>
    );
}
